module.exports = __webpack_public_path__ + "img/copa_live_countdown_bg.74ae24c5.jpg";